import { IJsonQuery } from '../types/jsonQuery';

export const JSON_QUERY_DEFAULT: IJsonQuery = {
  from_developer: {
    type: 'term',
    value: true,
  },
};
